/* "Complete your look" in the bag: one tap adds the case (already set to the
   shopper's phone model) and redraws the bag in place. */
(() => {
  if (window.cloudUpsellBound) return;
  window.cloudUpsellBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cloud-upsell-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(`${(window.Shopify?.routes?.root || '/').replace(/\/$/, '')}/cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.cloudUpsellAdd), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      }).then((r) => r.json());
      const bag = document.querySelector('cart-drawer');
      if (response?.sections && bag && typeof bag.renderContents === 'function') {
        bag.renderContents(response);
      } else {
        throw new Error(response?.description || 'add failed');
      }
    } catch (_error) {
      button.disabled = false;
      button.textContent = 'Try again';
    }
  });
})();
